import { Translation } from "@/data/lang";

export const videoUrlList = [
  {
    en: {
      mp4: "/home/video/01en.mp4",
      ogg: "/home/video/01en.ogg",
    },
    zh: {
      mp4: "/home/video/01zh.mp4",
      ogg: "/home/video/01zh.ogg",
    },
  },
  {
    en: {
      mp4: "/home/video/02en.mp4",
      ogg: "/home/video/02en.ogg",
    },
    zh: {
      mp4: "/home/video/02zh.mp4",
      ogg: "/home/video/02zh.ogg",
    },
  },
  {
    en: {
      mp4: "/home/video/03en.mp4",
      ogg: "/home/video/03en.ogg",
    },
    zh: {
      mp4: "/home/video/03zh.mp4",
      ogg: "/home/video/03zh.ogg",
    },
  },
  {
    en: {
      mp4: "/home/video/04en.mp4",
      ogg: "/home/video/04en.ogg",
    },
    zh: {
      mp4: "/home/video/04zh.mp4",
      ogg: "/home/video/04zh.ogg",
    },
  },
] as const;

export const getAccordionData = (t: Translation) => [
  {
    title: t.home.roboSection.AIInvestment.title,
    content: t.home.roboSection.AIInvestment.content,
  },
  {
    title: t.home.roboSection.quickAndConvenient.title,
    content: t.home.roboSection.quickAndConvenient.content,
  },
  {
    title: t.home.roboSection.customizedPortfolio.title,
    content: t.home.roboSection.customizedPortfolio.content,
  },
  {
    title: t.home.roboSection.lowMaintenanceFeeAndTransparency.title,
    content: t.home.roboSection.lowMaintenanceFeeAndTransparency.content,
  },
];
